import { EMPTY_STRING, FIRST_ELEMENT, STEP } from '@constants';

export const capitalizeFirstLetter = (str?: string) => {
  if (!str) return EMPTY_STRING;

  return str.charAt(FIRST_ELEMENT).toUpperCase() + str.slice(STEP).toLowerCase();
};
